import { useCallback, useMemo, useState } from 'react'
import { descend, map, pipe, prop, sort } from 'ramda'
import moment from 'moment-timezone'

import { HistoryItem as TemplateItem } from 'app/common/templates-next/report-template'
import { ReportType } from 'app/dataTypes/reports'
import { History, HistoryItem } from 'app/dataTypes/reports/history'
import { useUser } from 'app/dataProviders/user/hooks'

import { api } from 'app/api'
import {
  GET_HISTORY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/reports/history/get'

export default function useHistoty(reportType: ReportType) {
  const [history, setHistory] = useState<History>([])
  const [loading, setLoading] = useState(true)
  const { email } = useUser()

  const requestHistory = useCallback(async () => {
    setLoading(true)
    const res: History | null = await api.request(GET_HISTORY, {
      error: 'Не удалось загрузить данные истории',
      params: {
        reportType,
        limit: 10,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setHistory(res || [])
    setLoading(false)
  }, [reportType])

  const items = useMemo(() => {
    return pipe(
      map<HistoryItem, TemplateItem>(({ id, title, createdAt, status }) => {
        const mCreateAt = moment(createdAt)
        return {
          id,
          title,
          date: mCreateAt.format('DD.MM.YYYY HH:mm:ss'),
          sortable: mCreateAt.valueOf(),
          options: <div />,
          email,
          status,
        }
      }),
      sort(descend(prop('sortable'))),
    )(history)
  }, [history, email])

  return {
    history: items,
    requestHistory,
    loading,
    setLoading,
  }
}
